var exports = {
  "selectorButton": "selectorButton__USDmx8",
  "avatarLeadingVisual": "avatarLeadingVisual__O7T0yf",
  "itemMeta": "itemMeta__KG5L-r",
  "disabledOrganizationItem": "disabledOrganizationItem__wV28Mf",
  "ownerPanel": "ownerPanel__duxvnt",
  "ownerHeader": "ownerHeader__I601hy",
  "ownerHeading": "ownerHeading__j3_2EA",
  "ownerSubtitle": "ownerSubtitle__cMZLhT",
  "ownerSearchLabel": "ownerSearchLabel__OYN0iY",
  "ownerSearch": "ownerSearch__AsaYjL",
  "ownerList": "ownerList__8bUjOq",
  "ownerEmpty": "ownerEmpty__8Iq_Eq",
};

__webpack_require__.r(module.exports = exports);
